"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        label: 'Afghanistan',
        value: 'Afghanistan',
    },
    {
        label: 'Akrotiri and Dhekelia',
        value: 'Akrotiri and Dhekelia',
    },
    {
        label: 'Åland Islands Åland',
        value: 'Åland Islands Åland',
    },
    {
        label: 'Albania',
        value: 'Albania',
    },
    {
        label: 'Alderney',
        value: 'Alderney',
    },
    {
        label: 'Algeria',
        value: 'Algeria',
    },
    {
        label: 'American Samoa',
        value: 'American Samoa',
    },
    {
        label: 'Andorra',
        value: 'Andorra',
    },
    {
        label: 'Angola',
        value: 'Angola',
    },
    {
        label: 'Anguilla',
        value: 'Anguilla',
    },
    {
        label: 'Antigua and Barbuda',
        value: 'Antigua and Barbuda',
    },
    {
        label: 'Argentina',
        value: 'Argentina',
    },
    {
        label: 'Armenia',
        value: 'Armenia',
    },
    {
        label: 'Artsakh',
        value: 'Artsakh',
    },
    {
        label: 'Aruba',
        value: 'Aruba',
    },
    {
        label: 'Australia',
        value: 'Australia',
    },
    {
        label: 'Australia Ashmore and Cartier Islands',
        value: 'Australia Ashmore and Cartier Islands',
    },
    {
        label: 'Australia Australian Antarctic Territory',
        value: 'Australia Australian Antarctic Territory',
    },
    {
        label: 'Australia Coral Sea Islands',
        value: 'Australia Coral Sea Islands',
    },
    {
        label: 'Australia Heard Island and McDonald Islands',
        value: 'Australia Heard Island and McDonald Islands',
    },
    {
        label: 'Austria',
        value: 'Austria',
    },
    {
        label: 'Azerbaijan',
        value: 'Azerbaijan',
    },
    {
        label: 'Bahamas',
        value: 'Bahamas',
    },
    {
        label: 'Bahrain',
        value: 'Bahrain',
    },
    {
        label: 'Bangladesh',
        value: 'Bangladesh',
    },
    {
        label: 'Barbados',
        value: 'Barbados',
    },
    {
        label: 'Belarus',
        value: 'Belarus',
    },
    {
        label: 'Belgium',
        value: 'Belgium',
    },
    {
        label: 'Belize',
        value: 'Belize',
    },
    {
        label: 'Benin',
        value: 'Benin',
    },
    {
        label: 'Bermuda',
        value: 'Bermuda',
    },
    {
        label: 'Bhutan',
        value: 'Bhutan',
    },
    {
        label: 'Bolivia',
        value: 'Bolivia',
    },
    {
        label: 'Bosnia and Herzegovina',
        value: 'Bosnia and Herzegovina',
    },
    {
        label: 'Botswana',
        value: 'Botswana',
    },
    {
        label: 'Bouvet Island',
        value: 'Bouvet Island',
    },
    {
        label: 'Brazil',
        value: 'Brazil',
    },
    {
        label: 'British Antarctic Territory',
        value: 'British Antarctic Territory',
    },
    {
        label: 'British Indian Ocean Territory',
        value: 'British Indian Ocean Territory',
    },
    {
        label: 'British Virgin Islands',
        value: 'British Virgin Islands',
    },
    {
        label: 'Brunei',
        value: 'Brunei',
    },
    {
        label: 'Bulgaria',
        value: 'Bulgaria',
    },
    {
        label: 'Burkina Faso',
        value: 'Burkina Faso',
    },
    {
        label: 'Burma',
        value: 'Burma',
    },
    {
        label: 'Burundi',
        value: 'Burundi',
    },
    {
        label: 'Cambodia',
        value: 'Cambodia',
    },
    {
        label: 'Cameroon',
        value: 'Cameroon',
    },
    {
        label: 'Canada',
        value: 'Canada',
    },
    {
        label: 'Cape Verde',
        value: 'Cape Verde',
    },
    {
        label: 'Caribbean Netherlands',
        value: 'Caribbean Netherlands',
    },
    {
        label: 'Cayman Islands',
        value: 'Cayman Islands',
    },
    {
        label: 'Central African Republic',
        value: 'Central African Republic',
    },
    {
        label: 'Chad',
        value: 'Chad',
    },
    {
        label: 'Chile',
        value: 'Chile',
    },
    {
        label: 'China',
        value: 'China',
    },
    {
        label: 'Christmas Island',
        value: 'Christmas Island',
    },
    {
        label: 'Clipperton Island',
        value: 'Clipperton Island',
    },
    {
        label: 'Cocos (Keeling) Islands',
        value: 'Cocos (Keeling) Islands',
    },
    {
        label: 'Collectivity of Saint Martin',
        value: 'Collectivity of Saint Martin',
    },
    {
        label: 'Colombia',
        value: 'Colombia',
    },
    {
        label: 'Comoros',
        value: 'Comoros',
    },
    {
        label: 'Congo, Democratic Republic of the',
        value: 'Congo, Democratic Republic of the',
    },
    {
        label: 'Congo, Republic of the',
        value: 'Congo, Republic of the',
    },
    {
        label: 'Cook Islands',
        value: 'Cook Islands',
    },
    {
        label: 'Costa Rica',
        value: 'Costa Rica',
    },
    {
        label: 'Croatia',
        value: 'Croatia',
    },
    {
        label: 'Cuba',
        value: 'Cuba',
    },
    {
        label: 'Curaçao',
        value: 'Curaçao',
    },
    {
        label: 'Cyprus',
        value: 'Cyprus',
    },
    {
        label: 'Czech Republic',
        value: 'Czech Republic',
    },
    {
        label: 'Denmark',
        value: 'Denmark',
    },
    {
        label: 'Djibouti',
        value: 'Djibouti',
    },
    {
        label: 'Dominica',
        value: 'Dominica',
    },
    {
        label: 'Dominican Republic',
        value: 'Dominican Republic',
    },
    {
        label: 'Ecuador',
        value: 'Ecuador',
    },
    {
        label: 'Egypt',
        value: 'Egypt',
    },
    {
        label: 'El Salvador',
        value: 'El Salvador',
    },
    {
        label: 'Equatorial Guinea – Republic of Equatorial Guinea',
        value: 'Equatorial Guinea – Republic of Equatorial Guinea',
    },
    {
        label: 'Eritrea',
        value: 'Eritrea',
    },
    {
        label: 'Estonia',
        value: 'Estonia',
    },
    {
        label: 'Ethiopia',
        value: 'Ethiopia',
    },
    {
        label: 'Falkland Islands',
        value: 'Falkland Islands',
    },
    {
        label: 'Faroe Islands',
        value: 'Faroe Islands',
    },
    {
        label: 'Fiji',
        value: 'Fiji',
    },
    {
        label: 'Finland',
        value: 'Finland',
    },
    {
        label: 'France',
        value: 'France',
    },
    {
        label: 'French Guiana',
        value: 'French Guiana',
    },
    {
        label: 'French Polynesia',
        value: 'French Polynesia',
    },
    {
        label: 'French Southern and Antarctic Lands',
        value: 'French Southern and Antarctic Lands',
    },
    {
        label: 'Gabon',
        value: 'Gabon',
    },
    {
        label: 'Gambia',
        value: 'Gambia',
    },
    {
        label: 'Georgia',
        value: 'Georgia',
    },
    {
        label: 'Germany',
        value: 'Germany',
    },
    {
        label: 'Ghana',
        value: 'Ghana',
    },
    {
        label: 'Gibraltar',
        value: 'Gibraltar',
    },
    {
        label: 'Greece',
        value: 'Greece',
    },
    {
        label: 'Greenland',
        value: 'Greenland',
    },
    {
        label: 'Grenada',
        value: 'Grenada',
    },
    {
        label: 'Guadeloupe',
        value: 'Guadeloupe',
    },
    {
        label: 'Guam',
        value: 'Guam',
    },
    {
        label: 'Guatemala',
        value: 'Guatemala',
    },
    {
        label: 'Guernsey',
        value: 'Guernsey',
    },
    {
        label: 'Guinea',
        value: 'Guinea',
    },
    {
        label: 'Guinea-Bissau',
        value: 'Guinea-Bissau',
    },
    {
        label: 'Guyana',
        value: 'Guyana',
    },
    {
        label: 'Haiti',
        value: 'Haiti',
    },
    {
        label: 'Herm',
        value: 'Herm',
    },
    {
        label: 'Honduras',
        value: 'Honduras',
    },
    {
        label: 'Hong Kong',
        value: 'Hong Kong',
    },
    {
        label: 'Hungary',
        value: 'Hungary',
    },
    {
        label: 'Iceland',
        value: 'Iceland',
    },
    {
        label: 'India',
        value: 'India',
    },
    {
        label: 'Indonesia',
        value: 'Indonesia',
    },
    {
        label: 'Iran',
        value: 'Iran',
    },
    {
        label: 'Iraq',
        value: 'Iraq',
    },
    {
        label: 'Ireland',
        value: 'Ireland',
    },
    {
        label: 'Northern Ireland',
        value: 'Northern Ireland',
    },
    {
        label: 'Isle of Man',
        value: 'Isle of Man',
    },
    {
        label: 'Israel',
        value: 'Israel',
    },
    {
        label: 'Italy',
        value: 'Italy',
    },
    {
        label: 'Ivory Coast',
        value: 'Ivory Coast',
    },
    {
        label: 'Jamaica',
        value: 'Jamaica',
    },
    {
        label: 'Jan Mayen',
        value: 'Jan Mayen',
    },
    {
        label: 'Japan',
        value: 'Japan',
    },
    {
        label: 'Jersey',
        value: 'Jersey',
    },
    {
        label: 'Jordan',
        value: 'Jordan',
    },
    {
        label: 'Kazakhstan',
        value: 'Kazakhstan',
    },
    {
        label: 'Kenya',
        value: 'Kenya',
    },
    {
        label: 'Kiribati',
        value: 'Kiribati',
    },
    {
        label: 'Korea, North',
        value: 'Korea, North',
    },
    {
        label: 'Korea, South',
        value: 'Korea, South',
    },
    {
        label: 'Kosovo',
        value: 'Kosovo',
    },
    {
        label: 'Kuwait',
        value: 'Kuwait',
    },
    {
        label: 'Kyrgyzstan',
        value: 'Kyrgyzstan',
    },
    {
        label: 'Laos',
        value: 'Laos',
    },
    {
        label: 'Latvia',
        value: 'Latvia',
    },
    {
        label: 'Lebanon',
        value: 'Lebanon',
    },
    {
        label: 'Lesotho',
        value: 'Lesotho',
    },
    {
        label: 'Liberia',
        value: 'Liberia',
    },
    {
        label: 'Libya',
        value: 'Libya',
    },
    {
        label: 'Liechtenstein',
        value: 'Liechtenstein',
    },
    {
        label: 'Lativia',
        value: 'Lativia',
    },
    {
        label: 'Lithuania',
        value: 'Lithuania',
    },
    {
        label: 'Luxembourg',
        value: 'Luxembourg',
    },
    {
        label: 'Macau',
        value: 'Macau',
    },
    {
        label: 'Macedonia',
        value: 'Macedonia',
    },
    {
        label: 'Madagascar',
        value: 'Madagascar',
    },
    {
        label: 'Malawi',
        value: 'Malawi',
    },
    {
        label: 'Malaysia',
        value: 'Malaysia',
    },
    {
        label: 'Maldives',
        value: 'Maldives',
    },
    {
        label: 'Mali',
        value: 'Mali',
    },
    {
        label: 'Malta',
        value: 'Malta',
    },
    {
        label: 'Marshall Islands',
        value: 'Marshall Islands',
    },
    {
        label: 'Martinique',
        value: 'Martinique',
    },
    {
        label: 'Mauritania',
        value: 'Mauritania',
    },
    {
        label: 'Mauritius',
        value: 'Mauritius',
    },
    {
        label: 'Mayotte',
        value: 'Mayotte',
    },
    {
        label: 'Mexico',
        value: 'Mexico',
    },
    {
        label: 'Micronesia',
        value: 'Micronesia',
    },
    {
        label: 'Moldova',
        value: 'Moldova',
    },
    {
        label: 'Monaco',
        value: 'Monaco',
    },
    {
        label: 'Mongolia',
        value: 'Mongolia',
    },
    {
        label: 'Montenegro',
        value: 'Montenegro',
    },
    {
        label: 'Montserrat',
        value: 'Montserrat',
    },
    {
        label: 'Morocco',
        value: 'Morocco',
    },
    {
        label: 'Mozambique',
        value: 'Mozambique',
    },
    {
        label: 'Myanmar',
        value: 'Myanmar',
    },
    {
        label: 'Namibia',
        value: 'Namibia',
    },
    {
        label: 'Nauru',
        value: 'Nauru',
    },
    {
        label: 'Nepal',
        value: 'Nepal',
    },
    {
        label: 'Netherlands',
        value: 'Netherlands',
    },
    {
        label: 'Netherlands Antilles',
        value: 'Netherlands Antilles',
    },
    {
        label: 'New Caledonia',
        value: 'New Caledonia',
    },
    {
        label: 'New Zealand',
        value: 'New Zealand',
    },
    {
        label: 'Nicaragua',
        value: 'Nicaragua',
    },
    {
        label: 'Niger',
        value: 'Niger',
    },
    {
        label: 'Nigeria',
        value: 'Nigeria',
    },
    {
        label: 'Niue',
        value: 'Niue',
    },
    {
        label: 'Norfolk Island',
        value: 'Norfolk Island',
    },
    {
        label: 'Northern Cyprus',
        value: 'Northern Cyprus',
    },
    {
        label: 'Northern Mariana Islands',
        value: 'Northern Mariana Islands',
    },
    {
        label: 'Norway',
        value: 'Norway',
    },
    {
        label: 'Oman',
        value: 'Oman',
    },
    {
        label: 'Pakistan',
        value: 'Pakistan',
    },
    {
        label: 'Palau',
        value: 'Palau',
    },
    {
        label: 'Palestine',
        value: 'Palestine',
    },
    {
        label: 'Panama',
        value: 'Panama',
    },
    {
        label: 'Papua New Guinea',
        value: 'Papua New Guinea',
    },
    {
        label: 'Paraguay',
        value: 'Paraguay',
    },
    {
        label: 'Peru',
        value: 'Peru',
    },
    {
        label: 'Peter I Island',
        value: 'Peter I Island',
    },
    {
        label: 'Philippines',
        value: 'Philippines',
    },
    {
        label: 'Pitcairn Islands',
        value: 'Pitcairn Islands',
    },
    {
        label: 'Poland',
        value: 'Poland',
    },
    {
        label: 'Portugal',
        value: 'Portugal',
    },
    {
        label: 'Puerto Rico',
        value: 'Puerto Rico',
    },
    {
        label: 'Qatar',
        value: 'Qatar',
    },
    {
        label: 'Queen Maud Land',
        value: 'Queen Maud Land',
    },
    {
        label: 'Reunion Island',
        value: 'Reunion',
    },
    {
        label: 'Romania',
        value: 'Romania',
    },
    {
        label: 'Ross Dependency',
        value: 'Ross Dependency',
    },
    {
        label: 'Russia',
        value: 'Russia',
    },
    {
        label: 'Rwanda',
        value: 'Rwanda',
    },
    {
        label: 'Sahara, Western – Sahrawi Arab Democratic Republic',
        value: 'Sahara, Western – Sahrawi Arab Democratic Republic',
    },
    {
        label: 'Saint Helena, Ascension and Tristan da Cunha',
        value: 'Saint Helena, Ascension and Tristan da Cunha',
    },
    {
        label: 'Saint Kitts and Nevis',
        value: 'Saint Kitts and Nevis',
    },
    {
        label: 'Saint Lucia',
        value: 'Saint Lucia',
    },
    {
        label: 'Saint Pierre and Miquelon',
        value: 'Saint Pierre and Miquelon',
    },
    {
        label: 'Saint Vincent and the Grenadines',
        value: 'Saint Vincent and the Grenadines',
    },
    {
        label: 'Saint-Barthélemy',
        value: 'Saint-Barthélemy',
    },
    {
        label: 'Samoa',
        value: 'Samoa',
    },
    {
        label: 'San Marino',
        value: 'San Marino',
    },
    {
        label: 'São Tomé and Príncipe',
        value: 'São Tomé and Príncipe',
    },
    {
        label: 'Sark',
        value: 'Sark',
    },
    {
        label: 'Saudi Arabia',
        value: 'Saudi Arabia',
    },
    {
        label: 'Scotland',
        value: 'Scotland',
    },
    {
        label: 'Senegal',
        value: 'Senegal',
    },
    {
        label: 'Serbia',
        value: 'Serbia',
    },
    {
        label: 'Seychelles',
        value: 'Seychelles',
    },
    {
        label: 'Sierra Leone',
        value: 'Sierra Leone',
    },
    {
        label: 'Singapore',
        value: 'Singapore',
    },
    {
        label: 'Sint Maarten',
        value: 'Sint Maarten',
    },
    {
        label: 'Slovakia',
        value: 'Slovakia',
    },
    {
        label: 'Slovenia',
        value: 'Slovenia',
    },
    {
        label: 'Solomon Islands',
        value: 'Solomon Islands',
    },
    {
        label: 'Somalia',
        value: 'Somalia',
    },
    {
        label: 'Somaliland',
        value: 'Somaliland',
    },
    {
        label: 'South Africa',
        value: 'South Africa',
    },
    {
        label: 'South Georgia and the South Sandwich Islands',
        value: 'South Georgia and the South Sandwich Islands',
    },
    {
        label: 'South Ossetia',
        value: 'South Ossetia',
    },
    {
        label: 'South Sudan',
        value: 'South Sudan',
    },
    {
        label: 'Spain',
        value: 'Spain',
    },
    {
        label: 'Sri Lanka',
        value: 'Sri Lanka',
    },
    {
        label: 'Sudan',
        value: 'Sudan',
    },
    {
        label: 'Suriname',
        value: 'Suriname',
    },
    {
        label: 'Svalbard',
        value: 'Svalbard',
    },
    {
        label: 'Swaziland',
        value: 'Swaziland',
    },
    {
        label: 'Sweden',
        value: 'Sweden',
    },
    {
        label: 'Switzerland',
        value: 'Switzerland',
    },
    {
        label: 'Syria',
        value: 'Syria',
    },
    {
        label: 'Taiwan',
        value: 'Taiwan',
    },
    {
        label: 'Tajikistan',
        value: 'Tajikistan',
    },
    {
        label: 'Tanzania',
        value: 'Tanzania',
    },
    {
        label: 'Thailand',
        value: 'Thailand',
    },
    {
        label: 'Timor-Leste',
        value: 'Timor-Leste',
    },
    {
        label: 'Togo',
        value: 'Togo',
    },
    {
        label: 'Tokelau',
        value: 'Tokelau',
    },
    {
        label: 'Tonga',
        value: 'Tonga',
    },
    {
        label: 'Transnistria',
        value: 'Transnistria',
    },
    {
        label: 'Trinidad and Tobago',
        value: 'Trinidad and Tobago',
    },
    {
        label: 'Tunisia',
        value: 'Tunisia',
    },
    {
        label: 'Turkey',
        value: 'Turkey',
    },
    {
        label: 'Turkmenistan',
        value: 'Turkmenistan',
    },
    {
        label: 'Turks and Caicos Islands',
        value: 'Turks and Caicos Islands',
    },
    {
        label: 'Tuvalu',
        value: 'Tuvalu',
    },
    {
        label: 'Uganda',
        value: 'Uganda',
    },
    {
        label: 'Ukraine',
        value: 'Ukraine',
    },
    {
        label: 'United Arab Emirates',
        value: 'United Arab Emirates',
    },
    {
        label: 'United Kingdom',
        value: 'United Kingdom',
    },
    {
        label: 'United States of America',
        value: 'United States of America',
    },
    {
        label: 'United States Minor Outlying Islands',
        value: 'United States Minor Outlying Islands',
    },
    {
        label: 'United States Virgin Islands',
        value: 'United States Virgin Islands',
    },
    {
        label: 'Uruguay',
        value: 'Uruguay',
    },
    {
        label: 'Uzbekistan',
        value: 'Uzbekistan',
    },
    {
        label: 'Vanuatu',
        value: 'Vanuatu',
    },
    {
        label: 'Vatican City',
        value: 'Vatican City',
    },
    {
        label: 'Venezuela',
        value: 'Venezuela',
    },
    {
        label: 'Vietnam',
        value: 'Vietnam',
    },
    {
        label: 'Wales',
        value: 'Wales',
    },
    {
        label: 'Wallis and Futuna',
        value: 'Wallis and Futuna',
    },
    {
        label: 'Yemen',
        value: 'Yemen',
    },
    {
        label: 'Zambia',
        value: 'Zambia',
    },
    {
        label: 'Zimbabwe',
        value: 'Zimbabwe',
    },
];
//# sourceMappingURL=countries.js.map